// extracted by mini-css-extract-plugin
export default {"managerDataDialog":"AddManagerDialog_managerDataDialog__n+P7m","submit":"AddManagerDialog_submit__tfM0-","submitText":"AddManagerDialog_submitText__Q3RyU"};